
let SDKInstance = null;
let loadingPromise = null;

export const initDuerSDK = () => {
  if (SDKInstance) return Promise.resolve(SDKInstance);
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    // 创建脚本标签
    const script = document.createElement('script');
    script.src = 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2023-7/1689143438187/duerwebsdk-1.3.0.js';
    script.async = true;
    script.defer = true;

    // 加载成功回调
    script.onload = () => {
      if (window.DUER_rtcsdk) {
        SDKInstance = window.DUER_rtcsdk;
        resolve(SDKInstance);
      } else {
        reject(new Error('DUER SDK 全局变量未正确挂载'));
      }
    };

    // 错误处理
    script.onerror = () => {
      reject(new Error('DUER SDK 脚本加载失败'));
    };

    document.body.appendChild(script);
  });

  return loadingPromise;
};

export const getDuerSDK = () => {
  if (!SDKInstance) throw new Error('请先初始化 DUER SDK');
  return SDKInstance;
};